<template>
  <div id="app" style="overflow: hidden;">
    <OfflineBar></OfflineBar>
    <OnlineBar v-if="showOnline"></OnlineBar>
    <loading-overlay :is-loading="isLoading"></loading-overlay>
    <router-view></router-view>
    <OfflineWarningModal></OfflineWarningModal>
    <FeatureUnavailableOfflineModal></FeatureUnavailableOfflineModal>
  </div>
</template>

<script>
  import LoadingOverlay from "./components/LoadingOverlay";
  import OfflineWarningModal from "./components/modals/OfflineWarningModal";
  import OfflineBar from "./components/layouts/OfflineBar";
  import OnlineBar from "./components/layouts/OnlineBar";
  import FeatureUnavailableOfflineModal from "./components/modals/FeatureUnavailableOfflineModal";
  import HelperMixin from "./mixins/HelperMixin";

  export default {
    name: "app",
    components: {
      LoadingOverlay,
      OfflineWarningModal,
      OfflineBar,
      OnlineBar,
      FeatureUnavailableOfflineModal
    },
    mixins: [HelperMixin],
    data() {
      return {
        showOnline: false
      }
    },
    computed: {
      isLoading() {
        return this.$store.getters["isLoading"];
      }
    },
    mounted() {
      window.addEventListener('online', this.updateOnlineStatus);
      window.addEventListener('offline', this.updateOnlineStatus);
    },
    beforeDestroy() {
      window.removeEventListener('online', this.updateOnlineStatus);
      window.removeEventListener('offline', this.updateOnlineStatus);
    },
    created() {
      this.checkAppInstalled();
      this.$store.dispatch('saveOnline', {
          online: navigator.onLine
      });
      if (!navigator.onLine) {
        $('#offlineWarningModal').modal('show');
      } else {
        this.createRespondentFromOffline();
      }
    },
    methods: {
      async checkOnlineStatus() {
      try {
        const online = await fetch("/api/v1/ping", {method: "POST"});
        let isOnline = online.status >= 200 && online.status < 300;
        this.$store.dispatch('saveOnline', {
            online: isOnline
        });
        if (isOnline) {
          this.showOnline = true;
          this.refreshData();
          this.createRespondentFromOffline();
          setTimeout(() => {
            this.showOnline = false;
          }, 5000);
        }
        return isOnline;
      } catch (err) {
        this.$store.dispatch('saveOnline', {
            online: false
        });
        return false;
      }
    },
      updateOnlineStatus(e) {
        const { type } = e;
        if (type === 'online') {
          var refreshIntervalId = setInterval(async () => {
            const result = await this.checkOnlineStatus();
            if (result) {
              clearInterval(refreshIntervalId);
            }
          }, 1000);
        } else {
          this.$store.dispatch('saveOnline', {
            online: false
          });
          $('#offlineWarningModal').modal('show');
        }
        
        if ( type === 'online') {
          $('.campaign-container').css("background-color", "");
        } else {
          $('.campaign-container').css("background-color", "#f0f0f0");
        }
      },
    }
  };
</script>
